export const styles = {
  formContainer: 'tw-space-y-6',
  formRow: 'tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4',
  fullWidthField: 'tw-col-span-1 md:tw-col-span-2',
  loadingOverlay: 'tw-absolute tw-inset-0 tw-bg-white tw-bg-opacity-75 tw-flex tw-items-center tw-justify-center tw-z-10',
};
